<template>
  <div>
    <AboutBanner :content="banners.find(item=>item.id==111).details" :title="banners.find(item=>item.id==111).title" :img="banners.find(item=>item.id==111).photo_file"/>
    <div class="mt-16" style="background: rgba(232,232,232,0.12)">
      <AboutTitle :title="$t('پروژه ها')" page-route="/sub/light-blocks/projects"/>
      <v-container>
        <v-row>
          <v-col v-for="(newsItem,i) in projects.topics" :key="i" cols="12">
            <BlockNewsItem :news-item="newsItem"/>
          </v-col>
        </v-row>
      </v-container>
      <div v-if="current<total"   @click="page++" class="d-flex justify-center">
        <div style="background-color: #74B73B; width: 200px; height: 44px" class="pointer d-flex justify-center align-center">
          <p class="white--text">مشاهده موارد بیشتر</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AboutTitle from "../../About/Components/AboutTitle";
import BlockNewsItem from "../components/BlockNewsItem";
import {mapState} from "vuex";
import AboutBanner from "../../About/Components/AboutBanner";
export default {
  name: 'BlockProjects',
  components: {AboutBanner, BlockNewsItem, AboutTitle},

  created() {
    if (this.banners==null){
      this.$store.dispatch('lightBlocksManagement/getBlockBanners');
    }
    this.$store.dispatch('lightBlocksManagement/getBlockProjects',{
      page:this.page
    }).then(
        ()=>{
         this.total+= this.projects.total_count;
          this.current = this.projects.topics.length;
        }
    );
  },
  computed:{
    ...mapState({
      projects:state => state.lightBlocksManagement.blockProjects,
      banners: state => state.lightBlocksManagement.blockBanners,
    })
  },

  data(){
    return{
      page:1,
      total:0,
      current:0,
    }
  },
  watch:{
    page(){
      this.$store.dispatch('lightBlocksManagement/getBlockProjects',{
        page:this.page
      }).then(
          () =>{
            this.current = this.projects.topics_count;
          }
      );
    }
  }
}
</script>
